<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">

    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
         <div class="flex flex-col sm:flex-row gap-2">
             <div class="relative">
                <input type="text" [(ngModel)]="search" (ngModelChange)="onSearch($event)" placeholder="Search.." class="pl-8" />
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                </svg>
            </div>
            <div>
                <select (change)="onSelectStatus($event)" id="inputStatus" class="min-w-40">
                    <option [value]="true">Active</option>
                    <option [value]="false">Inactive</option>
                </select>
            </div>
        </div>
        <div *ngIf="fundingSources && fundingSources.length">
            <h1 class="text-xs text-nowrap text-left">Showing {{(numberOfRecords * currentPage) - (fundingSources.length != numberOfRecords? (numberOfRecords
                -fundingSources.length) : 0) }} of {{totalResults }} entries
            </h1>
        </div>
        <div>
            <button routerLink="add" *ngIf="permissionService.hasPermission([userPermission.MANAGE_FUNDING_SOURCE])" class="btn btn-secondary">
                Add
            </button>
        </div>

    </div>

    <div class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
        <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
            <div class="flow-root h-full overflow-y-auto">
                <div class="-my-2">
                    <div class="inline-block min-w-full py-2 align-middle">
                        <table class="min-w-full border-separate border-spacing-0">
                            <thead>
                                <tr>
                                     <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        #
                                    </th>
                                    <th *ngIf="permissionService.hasAnyPermission([userPermission.MANAGE_FUNDING_SOURCE, userPermission.GET_FARES])"
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Action
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Name
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Address
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Contact Number
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Phone Number
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Account Status
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Status
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of fundingSources | paginate: { itemsPerPage:numberOfRecords, currentPage: currentPage, totalItems:totalResults}; let i=index"
                                    class="hover:bg-gray-950/5 dark:hover:bg-white/10">
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                       {{i+1}}
                                    </td>
                                    <td *ngIf="permissionService.hasAnyPermission([userPermission.MANAGE_FUNDING_SOURCE, userPermission.GET_FARES])"
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap" >
                                        <div class="flex gap-2 items-center">
                                            <!-- routerLink="{{item.id}}/edit" -->
                                            <a [appToolTip]="'Edit'" *ngIf="permissionService.hasPermission([userPermission.MANAGE_FUNDING_SOURCE])" href="javascript:void(0)" (click)="openFundingSourceModal(item)"
                                            class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400 pr-2 border-r border-zinc-300 dark:border-white/20">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="2" stroke="currentColor" class="size-5">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                                            </svg>
                                            </a>
                                            <a [appToolTip]="'Fare'" *ngIf="permissionService.hasPermission([userPermission.GET_FARES])" (click)="openFareWindow(item.id)" href="javascript:void(0)"
                                                class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">

                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                    stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                                </svg>

                                            </a>
                                        </div>
                                    </td>

                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
                                        <div class="flex items-center space-x-2">
                                            <div
                                                class=":col-start-1 overflow-hidden :row-start-1 inline-grid size-10 shrink-0 rounded-[--avatar-radius] align-middle outline outline-1 -outline-offset-1 outline-black/[--ring-opacity] [--avatar-radius:20%] [--ring-opacity:20%] *:rounded-[--avatar-radius] dark:outline-white/[--ring-opacity]">

                                                <!-- <img [src]="item.profileImageURL ? item.profileImageURL : 'assets/images/funding-source-image.png'"
                                                    class="relative size-full text-gray-400" alt="Profile Image" /> -->
                                                    <img [src]="item.profileImageURL ? item.profileImageURL : 'assets/images/funding-source-white-image.png'" class="relative size-full text-gray-400 hidden dark:block" alt="Profile Image" />
                                                    <img [src]="item.profileImageURL ? item.profileImageURL : 'assets/images/funding-source-image.png'" class="relative size-full text-gray-400 dark:hidden" alt="Profile Image" />
                                            </div>

                                            <div class="leading-none">
                                                <div class="text-sm-dark text-nowrap">{{item.title | titlecase}}</div>
                                                <div class="text-nowrap">{{ item.email || 'N/A' }}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{item.address && item.address.name ? item.address.name : 'N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap" phoneNumberFormat [phoneNumber]="item?.contactNumber">
                                        {{item.contactNumber}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap" phoneNumberFormat [phoneNumber]="item?.phoneNumber">
                                        {{item.phoneNumber || 'N/A'}}
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span *ngIf="item.accountStatus" [ngClass]="item.accountStatus === 'normal' ? 'badge-success' : 'badge-danger'" class="">
                                            {{item.accountStatus | titlecase}}
                                        </span>
                                    </td>
                                    <td
                                        class="space-x-2 px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span *ngIf="item.isDefault" class="badge-primary">
                                            Default
                                        </span>
                                        <span [ngClass]="item.isActive ? 'badge-success' : 'badge-danger'" class="">
                                            {{item.isActive ? 'Active' : 'Inactive'}}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex justify-end">
            <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
        </div>
    </div>
    
</section>

<app-funding-source-edit-modal
  *ngIf="fundingSourceModalObj"
  [fundingSource]="fundingSourceModalObj"
  (onSave)="onSaveFundingSource($event)"
  (onCloseModal)="onCloseFundingSourceModal()"
></app-funding-source-edit-modal>